/* Product page: the friend idles on its little stage (a hop now and then), pokes make it squish and squeak.
   Options pick the variant, the tote button sends it flying into the bag, a slim bar follows on phones. */
(function () {
  'use strict';
  var WH = window.WH;
  if (!WH) return;
  WH.register('product', function (sec) {
    var form = sec.querySelector('#WhProductForm') || sec.querySelector('form');
    var variants = [];
    try { variants = JSON.parse(sec.querySelector('[data-variants]').textContent); } catch (e) {}
    var idInput = sec.querySelector('[data-variant-id]'), priceEl = sec.querySelector('[data-price]');
    var addBtn = sec.querySelector('[data-add-btn]'), addLabel = sec.querySelector('[data-add-label]');
    var star = sec.querySelector('[data-star]'), starImg = sec.querySelector('#WhStarImg');
    var bar = sec.querySelector('[data-bar]'), barPrice = sec.querySelector('[data-bar-price]');
    var money = WH.money;

    if (form) { form.setAttribute('data-add', ''); form.setAttribute('data-add-img', '#WhStarImg'); }

    /* options -> variant */
    var radios = Array.prototype.slice.call(sec.querySelectorAll('[data-opt]'));
    function pick() {
      var chosen = [];
      radios.forEach(function (r) { if (r.checked) chosen[+r.getAttribute('data-opt')] = r.value; });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return chosen[i] === undefined || chosen[i] === o; }); });
      if (!v) return;
      idInput.value = v.id;
      priceEl.textContent = money(v.price);
      if (barPrice) barPrice.textContent = money(v.price);
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? addLabel.getAttribute('data-add') || addLabel.textContent : addLabel.getAttribute('data-out') || addLabel.textContent;
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
      if (WH.anim) gsap.fromTo(priceEl, { scale: 1.25, rotation: -4 }, { scale: 1, rotation: 0, duration: 0.34, ease: WH.sm('back.out(2.4)', 0.34) });
      WH.sound.play('pop');
      /* each attachment has its own picture: show it on the stage */
      var thumb = v.featured_media && sec.querySelector('[data-media="' + v.featured_media.id + '"]');
      if (thumb && !thumb.classList.contains('is-on')) thumb.click();
    }
    radios.forEach(function (r) { r.addEventListener('change', pick); });

    /* quantity */
    var q = sec.querySelector('[data-q-input]');
    sec.querySelectorAll('[data-q]').forEach(function (b) {
      b.addEventListener('click', function () { q.value = WH.clamp((parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-q'), 10), 1, 20); });
    });

    /* the star of the show */
    var set = star ? star.closest('.wh-pdp__set') : null, idle = null;
    if (star && WH.anim) {
      idle = gsap.timeline({ repeat: -1, repeatDelay: 2.4, delay: 1 })
        .to(star, { scaleX: 1.08, scaleY: 0.9, duration: 0.17, ease: 'none', transformOrigin: '50% 100%' })
        .to(star, { y: -36, scaleX: 0.95, scaleY: 1.06, duration: 0.34, ease: WH.sm('power2.out', 0.34) })
        .to(star, { y: 0, scaleX: 1, scaleY: 1, duration: 0.25, ease: WH.sm('power2.in', 0.25) })
        .to(star, { scaleX: 1.08, scaleY: 0.92, duration: 0.09, ease: 'none' })
        .to(star, { scaleX: 1, scaleY: 1, duration: 0.17, ease: WH.sm('power1.out', 0.17) });
      star.setAttribute('data-poke', '');
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { if (en[0].isIntersecting && !set.classList.contains('is-photo')) idle.resume(); else idle.pause(); }).observe(star);
      star.addEventListener('click', function (e) {
        if (set && set.classList.contains('is-photo')) return;  /* a scene photo is not a felt friend to poke */
        idle.pause();
        WH.sound.play('squeak');
        WH.puff(e.clientX, e.clientY, 6);
        gsap.timeline({ onComplete: function () { idle.restart(true); } })
          .to(star, { scaleX: 1.2, scaleY: 0.78, duration: 0.09, ease: 'none', transformOrigin: '50% 100%' })
          .to(star, { scaleX: 1, scaleY: 1, rotation: WH.rand(-8, 8), duration: 0.5, ease: WH.sm('elastic.out(1.3,.35)', 0.5) })
          .to(star, { rotation: 0, duration: 0.17 });
      });
    }

    /* thumbnails swap like frames; every frame is fetched and decoded once the page has settled, and a swap waits for its
       frame to be ready, so switching never shows a half-loaded picture or the old one stretched into the new layout */
    var frames = {};
    /* frames are linked at 1100 px; a phone's stage needs about 700, so ask the CDN for the width the stage really shows */
    var stageW = 1100, shown = starImg ? starImg.offsetWidth : 0;  /* offsetWidth: the hop's scale doesn't count */
    /* the width the browser already took from srcset, so the first frame is the same file, not a second download (10-27 PageSpeed) */
    var picked = starImg && (starImg.currentSrc || '').match(/[?&]width=(\d+)/);
    if (picked) stageW = +picked[1];
    else if (shown > 0) stageW = Math.min(1100, Math.max(500, Math.ceil(shown * (window.devicePixelRatio || 1) / 100) * 100));
    sec.querySelectorAll('[data-thumb]').forEach(function (t) { t.setAttribute('data-thumb', t.getAttribute('data-thumb').replace(/([?&]width=)\d+/, '$1' + stageW)); });
    var frame = function (url) {
      if (!frames[url]) {
        var im = new Image();
        im.decoding = 'async';
        im.src = url;
        frames[url] = im.decode ? im.decode().catch(function () {}) : new Promise(function (ok) { im.onload = im.onerror = ok; });
      }
      return frames[url];
    };
    var warm = function () { sec.querySelectorAll('[data-thumb]').forEach(function (t) { frame(t.getAttribute('data-thumb')); }); };
    if (document.readyState === 'complete') setTimeout(warm, 200); else window.addEventListener('load', function () { setTimeout(warm, 200); });
    sec.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('pointerenter', function () { frame(t.getAttribute('data-thumb')); });
      t.addEventListener('click', function () {
        sec.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.toggle('is-on', x === t); });
        if (!starImg) return;
        var url = t.getAttribute('data-thumb'), photo = t.hasAttribute('data-photo');
        frame(url).then(function () {
          if (!t.classList.contains('is-on')) return; /* another frame was picked meanwhile */
          if (set) set.classList.toggle('is-photo', photo);
          if (idle) { if (photo) { idle.pause(); gsap.set(star, { clearProps: 'transform' }); } else idle.restart(true); }
          starImg.removeAttribute('srcset');
          starImg.src = url;
          if (WH.anim && !photo) gsap.fromTo(starImg, { scaleX: 1.15, scaleY: 0.85 }, { scaleX: 1, scaleY: 1, duration: 0.34, ease: WH.sm('elastic.out(1.2,.4)', 0.34) });
        });
      });
    });

    /* slim bar on phones: shows once the tote button has scrolled away, steps aside at the footer */
    if (bar && addBtn) {
      var shown = null, tick = false, foot = document.querySelector('.wh-end');
      var check = function () {
        tick = false;
        var on = addBtn.getBoundingClientRect().bottom < 0 && !(foot && foot.getBoundingClientRect().top < window.innerHeight * 0.6);
        if (on === shown) return;
        shown = on;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        bar.querySelector('[data-bar-add]').tabIndex = on ? 0 : -1;
      };
      window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(check); } }, { passive: true });
      check();
      bar.querySelector('[data-bar-add]').addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else addBtn.click(); });
    }

    /* gang of four (the "more friends" row below): tick 3 friends from the same scene, then this friend and those 3 go into
       the tote together; the buy-3-get-1 discount makes the lowest-priced one free in the cart */
    var gang = document.querySelector('[data-gang]');
    if (gang) {
      var picks = Array.prototype.slice.call(gang.querySelectorAll('[data-gang-pick]'));
      var count = gang.querySelector('[data-gang-count]'), gBtn = gang.querySelector('[data-gang-add]'), gErr = gang.querySelector('[data-gang-err]');
      var tpl = count ? count.getAttribute('data-tpl') : '';
      var sync = function () {
        var n = picks.filter(function (p) { return p.checked; }).length;
        if (count) count.textContent = tpl.replace('[n]', n);
        picks.forEach(function (p) {
          if (!p.checked) p.disabled = n >= 3;
          var box = p.closest('[data-box]'); if (box) box.classList.toggle('is-picked', p.checked);
        });
        if (gBtn) gBtn.disabled = n !== 3;
      };
      picks.forEach(function (p) { p.addEventListener('change', function () { sync(); WH.sound.play(p.checked ? 'pop' : 'squeak'); }); });
      if (gBtn) gBtn.addEventListener('click', function () {
        var items = [{ id: +idInput.value, quantity: 1 }].concat(picks.filter(function (p) { return p.checked; }).map(function (p) { return { id: +p.value, quantity: 1 }; }));
        gBtn.disabled = true;
        if (gErr) gErr.hidden = true;
        WH.cart.add({ items: items }, starImg)
          .then(function () { picks.forEach(function (p) { p.checked = false; }); sync(); })
          .catch(function (x) { if (gErr) { gErr.textContent = x.message; gErr.hidden = false; } gBtn.disabled = false; });
      });
      sync();
    }
  });
})();
